import { Injectable } from '@angular/core';
import * as moment_ from 'moment';
const moment = moment_;
import {Moment} from 'moment';
@Injectable({
  providedIn: 'root'
})
export class DateUtilsService {

  constructor() { }

   isSame(firstDate , secondDate ) {
    if (firstDate && secondDate) {
      return moment(firstDate).isSame(secondDate , 'date');
    } else {
      return false;
    }
  }

  getDayNum(date: Moment , locale) {
    return date.locale(locale).format('D').toString();
  }

  getlocaleDayNames(locale): string[] {
    moment.locale(locale);
    return moment.weekdaysShort();
  }

  isToday(day: Moment) {
    return moment().isSame(day , 'date');
  }
}
